import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { confirmCME, getUserDetails, persistantLogin, logout } from "../actions";
import { LoadingCard } from "../components";
import { getLocalStorage } from "../common";

class SplashScreen extends Component {
    logRedirect = (reason, details = {}) => {
        console.warn("[SASP Splash Redirect]", reason, details);
    };

    state = {
        cme_flag: true,
        cmeYears_length: -1,
        cmeYears_current: 0,
        cme_confirmations: 0, 
        show: false,
        checking: true
    };

    componentDidMount = async () => {
        this.logRedirect("Splash screen mounted", {
            auth: this.props.auth,
            loginDt: getLocalStorage('login_dt'),
            authFeedback: this.props.auth_feedback
        });

        if (
            !this.props.auth &&
            typeof getLocalStorage('login_dt') !== 'undefined' && 
            getLocalStorage('login_dt') != null
        ) {    
            const _date = new Date();
            const _expire = Number(getLocalStorage('login_dt'));
            const _now = Number(Date.parse(_date));
            
            if (_now < _expire) {
                this.logRedirect("Persisted login is still valid; restoring auth", {
                    now: _now,
                    expire: _expire
                });
                await this.props.persistantLogin();
            } else {
                this.logRedirect("Persisted login expired; not restoring auth", {
                    now: _now,
                    expire: _expire
                });
            }
        } else if (!this.props.auth) {
            this.logRedirect("No valid persisted login found; auth state is still false", {
                loginDt: getLocalStorage('login_dt')
            });
        }

        const { auth_feedback } = this.props;

        if (auth_feedback && auth_feedback.mcid && auth_feedback.key) {
            await this.props.getUserDetails(auth_feedback.mcid, auth_feedback.key);
        }

        return this.setState({
            ...this.state,
            cme_flag: false,
            show: true,
            checking: false
        });
    };
    
    render() {
        if (this.state.checking || !this.state.show) {
            return (
                <LoadingCard textarray={["Welcome to the AUA SASP App."]}/>
            )
        } else {
            if (typeof this.props.user_details === 'undefined') {
                this.logRedirect("Redirecting to /error because user_details is undefined", {
                    auth_feedback: this.props.auth_feedback,
                    user_details: this.props.user_details
                });
                return (
                    <Redirect to={{pathname:"/error", message:"Error: Incomplete User Profile"}}/>
                )
            } else if (this.props.user_details.cmeYears === "No SASP Purchased") {
                this.logRedirect("Redirecting to /login because user_details.cmeYears is 'No SASP Purchased'", {
                    user_details: this.props.user_details,
                    auth_feedback: this.props.auth_feedback
                });
                // return this.props.logout();
                if (localStorage.length > 0 ) {
                    localStorage.clear();
                }
                
                return (
                    <Redirect to={{ pathname: "/login" }} />
                    
                );
            } else if (Number(this.props.user_details.newUser)) {
                this.logRedirect("Redirecting to /profile because newUser is true", {
                    user_details: this.props.user_details
                });
                return <Redirect to={{pathname: '/profile'}} />;
            } else {
                this.logRedirect("Redirecting to /home", {
                    user_details: this.props.user_details
                });
                return <Redirect to={{ pathname: "/home" }} />;
            }
        }
    }
}

const mapStateToProps = state => {
    const { auth, auth_feedback } = state.auth;
    const { user_details, cme_confirmations } = state.auth;
    return { auth, auth_feedback, user_details, cme_confirmations };
};

export default connect(mapStateToProps, { getUserDetails, confirmCME, logout, persistantLogin })(
    SplashScreen
);
